var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2748_39126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0601 6.69V16.81",
    stroke: "#0076FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68994 4.44H17.3799",
    stroke: "#0076FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.43994 16.81V6.69",
    stroke: "#0076FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8099 19.06H6.68994",
    stroke: "#0076FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeDasharray: "1.5 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13 2.75H2.75V6.13H6.13V2.75Z",
    fill: "white",
    stroke: "#0076FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13 17.38H2.75V20.76H6.13V17.38Z",
    fill: "white",
    stroke: "#0076FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7599 2.75H17.3799V6.13H20.7599V2.75Z",
    fill: "white",
    stroke: "#0076FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7599 17.38H17.3799V20.76H20.7599V17.38Z",
    fill: "white",
    stroke: "#0076FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93994 11.75H14.5599",
    stroke: "#0076FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 14.56V8.94",
    stroke: "#0076FF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2748_39126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5,
    height: 19.5,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEdit);
export default __webpack_public_path__ + "static/media/ico-edit.7a5962b0d0429f400695ebcfcdef3f7c.svg";
export { ForwardRef as ReactComponent };